export const RESOURCE_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  COMPLETED: 'COMPLETED',
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  REVISION: 'REVISION',
  NOT_YET_SATISFACTORY: 'NOT_YET_SATISFACTORY',
  SATISFACTORY: 'SATISFACTORY',
  CLOSED: 'CLOSED',
  IN_PROGRESS: 'IN_PROGRESS',
  LOCKED: 'LOCKED',
  AWAITING_SUBMISSION: 'AWAITING_SUBMISSION',
  WITHDRAWN: 'WITHDRAWN',
  RECOGNITION_OF_PRIOR_LEARNING: 'RECOGNITION_OF_PRIOR_LEARNING',
  THEORY_TRANSFER: 'THEORY_TRANSFER',
  CREDIT_TRANSFER: 'CREDIT_TRANSFER',
  NOT_REQUIRED: 'NOT_REQUIRED',
  NOT_YET_AVAILABLE: 'NOT_YET_AVAILABLE',
  ON_TRACK: 'ON_TRACK',
  OVERDUE: 'OVERDUE',
  AT_RISK: 'AT_RISK',
  PAUSED: 'PAUSED',
  DELETED: 'DELETED',
  SUPERSEDED: 'SUPERSEDED',
  PENDING_SUPERSESSION: 'PENDING_SUPERSESSION',
  PENDING_REVIEW: 'PENDING_REVIEW',
} as const;

export type RESOURCE_STATUSES_TYPE = (typeof RESOURCE_STATUSES)[keyof typeof RESOURCE_STATUSES];

export function isResourceStatus(value: unknown): value is RESOURCE_STATUSES_TYPE {
  return (
    typeof value === 'string' &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    Object.values(RESOURCE_STATUSES).includes(value as RESOURCE_STATUSES_TYPE)
  );
}
